import { home } from '@/api/index'

export function getHomeStatisticsData () {
  return home.request({
    method: 'post',
    url: '/GetHomeStatisticsData'
  })
}
